import { useContext } from 'react'
import { UserDataContext } from '../HOCs/withAuth'

function useUserData() {
    return useContext(UserDataContext)
}
export default useUserData
